// Copyright (c) 2017 Deere & Company

import React, {PropTypes} from 'react';
import FileAttachmentSinglePanel from '../../../shared/components/file-attachment-single-panel';
import {FormattedMessage} from 'react-intl';
import Invoice from '@deere/cps-it.warranty-model-factory/lib/invoice';
import LabeledDateInput from '../../../shared/components/claim-fields/labeled-date-input';
import LabeledInput from '../../../shared/components/claim-fields/labeled-input';
import {getServiceConfig} from '../../../shared/services/claim-shared-helper';
import moment from 'moment';

const canSubmitInvoice = (invoiceNumber, invoiceDate) =>
    invoiceNumber.length && invoiceDate !== null;

function handleInvoiceNumberChange(value) {

    const trimmedValue = value.replace(/\s+/g, '');

    this.onInvoiceNumberChange(trimmedValue);

}

function handleInvoicedDateChange(date) {

    const value = date ?
        date.valueOf() :
        null;

    this.onInvoicedDateChange(value);

}

function handleFileUploadSuccess(file, dropzone) {

    this.onInvoiceAddition(JSON.parse(file.xhr.response));
    dropzone.removeFile(file);

}

function handleFileDelete(file) {

    this.onInvoiceDelete(file);

}

function handleCancelClick() {

    this.onCancelClick();

}

function handleInvoiceSubmission() {

    this.onInvoiceSubmission();

}

const ListItemForm = props =>
    <section className='list-item-form'>
        <div className='editable-row'>
            <LabeledInput
                className='invoice-number'
                isEditable={true}
                label='INVOICE_NUMBER'
                onChange={props::handleInvoiceNumberChange}
                value={props.invoice.claimsProcess.dealerInvoiceNumber ? props.invoice.claimsProcess.dealerInvoiceNumber.replace(/\s+/g, '') : ''}
            />
            <LabeledDateInput
                className='invoiced-date'
                date={props.invoice.claimsProcess.dateOfDealerInvoice}
                isEditable={true}
                isValid={true}
                label='INVOICED'
                maxDate={moment()}
                onDateChange={props::handleInvoicedDateChange}
            />
            {props.invoice.claimsProcess.claimNumber &&
                <FileAttachmentSinglePanel
                    file={props.invoice.claimsProcess.file}
                    onFileDelete={props::handleFileDelete}
                    onFileUploadSuccess={props::handleFileUploadSuccess}
                    serviceConfig={getServiceConfig(props.invoice.claimsProcess.claimNumber)}
                />
            }
        </div>
        <footer className='button-group'>
            <button
                onClick={props::handleCancelClick}
            >
                <FormattedMessage id='CANCEL'/>
            </button>
            <button
                className='primary'
                disabled={!canSubmitInvoice(props.invoice.claimsProcess.dealerInvoiceNumber, props.invoice.claimsProcess.dateOfDealerInvoice)}
                onClick={props::handleInvoiceSubmission}
            >
                <FormattedMessage id='SUBMIT'/>
            </button>
        </footer>
    </section>;

ListItemForm.displayName = 'ListItemForm';
ListItemForm.propTypes = {
    invoice: PropTypes.instanceOf(Invoice).isRequired,
    onCancelClick: PropTypes.func.isRequired,
    onInvoiceAddition: PropTypes.func.isRequired,
    onInvoiceDelete: PropTypes.func.isRequired,
    onInvoiceNumberChange: PropTypes.func.isRequired,
    onInvoiceSubmission: PropTypes.func.isRequired,
    onInvoicedDateChange: PropTypes.func.isRequired
};

export default ListItemForm;



// WEBPACK FOOTER //
// ./src/claim/dealer-invoices/components/claim-process-invoice/list-item-form.js